import { classNames } from "primereact/utils";
import React from "react";

type Props = {
  id: string;
  invalid?: boolean;
  children: React.ReactNode;
  className?: string;
};
export const HelpText = ({ id, invalid, children, className }: Props) => {
  return (
    <small
      className={classNames("text-sm font-medium", className, {
        "text-urbe-errorValidation": invalid,
        "text-urbe-textSecondary": !invalid,
      })}
      id={id}
      role="note"
    >
      {children}
    </small>
  );
};
